import {Injectable} from '@angular/core';
import {Http, Headers} from '@angular/http';
import {ErrorInterceptor} from './ErrorInterceptor';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { TokenStorage } from '../TokenStorage';
import { HttpClient, HttpHeaders } from '@angular/common/http';

declare let ENDPOINT_LUDYAPI: string;
declare let NAMESPACE_LUDYACCOUNT: string;

@Injectable()
export class LoginHttp {

    constructor(private http: HttpClient, private errorInterceptor: ErrorInterceptor, private tokenStorage: TokenStorage) {
    }
    
    validateUser(param: any): Observable<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + 'account/user/login';
        let request = this.http.put(url, param);

        return request.pipe(map(response => response), catchError(this.errorInterceptor.handleErrorObs));
    }

    /**
     * Paso 2 de 2FA: envia el codigo OTP junto con el token2FA recibido en el login.
     * Mismo endpoint que validateUser; devuelve el token normal si el codigo es valido.
     */
    verify2FA(param: any): Observable<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + 'account/user/login';
        let request = this.http.put(url, param);

        return request.pipe(map(response => response), catchError(this.errorInterceptor.handleErrorObs));
    }

    validateToken(): Observable<any> {
        let param = { productlogin: 'LudyAccount'};
        // Get token
        let token: any;
        if ( this.tokenStorage.getToken() ) {
        token = this.tokenStorage.getToken();
        } else if ( this.tokenStorage.getCookie() ) {
        token = this.tokenStorage.getCookie();
        }
        if (token !== undefined) {
            let headers = new HttpHeaders();
            headers.append('Authorization', 'Bearer ' + token);

            let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + 'system/test';
            let request = this.http.put(url, null);
            return request.pipe(map(response => response), catchError(this.errorInterceptor.handleErrorObs));
        } else {
            return new Observable();
        }
    }

    getUserData(): Observable<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + 'usuario';
        let request = this.http.put(url, null);

        return request.pipe(map(response => response), catchError(this.errorInterceptor.handleErrorObs));
    }

    logOut(param?: any): Observable<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + 'account/user/logout';
        let request = this.http.put(url, param);

        return request.pipe(map(response => response), catchError(this.errorInterceptor.handleErrorObs));
    }
}
